<div *ngIf="hasChange===false" class="flex flex-col">
  <div class="note w-p-100">
    <div>
      <span>Note:</span> Please make sure to mark at least one item as approved or rejected by using the review controls
      on this screen before submitting your response.
    </div>
  </div>
</div>

<div *ngIf="hasChange" class="flex flex-col">
  <!--  <div class="note w-p-100 m-b-20" fxFlex="1 0 0 0">-->
  <!--    <div>-->
  <!--      <span>Note:</span> Please make sure to mark at least one item as approved or rejected by using the review controls-->
  <!--      on this screen before confirming changes.-->
  <!--    </div>-->
  <!--  </div>-->
  <div class="flex flex-row justify-start items-center auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Message</mat-label>
      <textarea matInput type="text" [(ngModel)]="data.input.message"
                rows="5">
              </textarea>
    </mat-form-field>
  </div>
</div>
